import { render, staticRenderFns } from "./GoldDiaStageResult.vue?vue&type=template&id=6d24caaa&"
import script from "./GoldDiaStageResult.vue?vue&type=script&lang=js&"
export * from "./GoldDiaStageResult.vue?vue&type=script&lang=js&"
import style0 from "./GoldDiaStageResult.vue?vue&type=style&index=0&id=6d24caaa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports